import type { Parameters } from '@atlaskit/editor-common/src/extensions';
import type { ForgeExtensionParameters } from '../types';

export const getConfig = ({ config, guestParams }: ForgeExtensionParameters | Parameters) =>
	guestParams || config;

export const transformConfigBefore = (parameters: ForgeExtensionParameters | Parameters) =>
	getConfig(parameters);
export const transformConfigAfter = (parameters: any) => ({ guestParams: parameters });
